/* Small badge combining channel name + exchange, used by the Trades and
   Channels tabs. Extracted from Dashboard.jsx during the 2026-02-14d refactor.
   Blofin gets `info` (sky) tone; falls back to `muted` for unknown exchanges. */
import React from "react";
import { Badge } from "@/components/atoms";

export function ChannelChip({ channel, rawId }) {
  if (!channel) {
    return (
      <span className="text-[10px] text-slate-400 mono">
        #{(rawId || "").slice(0, 8)}
      </span>
    );
  }
  const tone =
    channel.exchange === "weex" ? "profit"
      : channel.exchange === "bitget" ? "warn"
      : channel.exchange === "blofin" ? "info"
      : channel.exchange === "gate" ? "profit"
      : "muted";
  return (
    <div className="flex flex-col gap-0.5">
      <span
        className="text-xs font-medium text-slate-800 truncate max-w-[160px]"
        title={channel.name}
      >
        {channel.name}
      </span>
      <Badge variant={tone} className="uppercase w-fit">
        {channel.exchange}
      </Badge>
    </div>
  );
}
